import {backendUrl, domainUrl} from "@/lib/Constants";
import { Exhibit, GalleriesFilter } from "@/common/entities/exhibits/Exhibit";
import {doGet} from "@/common/helpers/fetch.helpers";

export type GalleryResponse = {
    data: Exhibit[];
    total: number;
};

export async function getGalleriesData(filters: GalleriesFilter): Promise<GalleryResponse> {
    const params: Record<string, string> = {
        from: filters.from.toString(),
        size: filters.size.toString(),
        siteDomain: domainUrl,
        tagsIds: Array.isArray(filters.tagsIds)
            ? filters.tagsIds.join(",")
            : filters.tagsIds ?? "",
        searchModel: filters.searchModel ?? ""
    };

    return doGet(`${backendUrl}/exhibits/all`, params);
}

export async function getAllTags(): Promise<any> {
    const params: Record<string, string> = {
        siteDomain: domainUrl,
    };

    return doGet(`${backendUrl}/tags/all`, params);
}
